import React from "react"
import {graphql, useStaticQuery, Link} from "gatsby"
import set_ev_color from '../helper_js/set_ev_color'
import return_spread from '../helper_js/return_spread'


import gameBoxStyles from './games_box.module.scss'

const Games = () => { 
    const data = useStaticQuery(graphql`
        query {
            allProjectedSpreadsCsv {
            nodes {
                game_id
                season
                week
                home_team_name
                away_team_name
                home_team_logo_espn
                away_team_logo_espn
                home_line_close
                home_closing_line_rounded_nfelo
                home_ev
                away_ev
                home_probability_nfelo
                last_week
                last_season
            }
            }
        }
    `)

    return (
        <div className={gameBoxStyles.game_container}>
            {data.allProjectedSpreadsCsv.nodes.map(node => {
                return (
                    <div className={gameBoxStyles.game_box}>
                        <Link className={gameBoxStyles.gameLink} to={`/games/${node.season}-week-${node.week}-${node.away_team_name.toLowerCase()}-at-${node.home_team_name.toLowerCase()}-betting-preview/`}>
                        <div className={gameBoxStyles.game_label_container}>
                            <table>
                                <col width='13%'></col>
                                <col width='31%'></col>
                                <col width='13%'></col>
                                <col width='13%'></col>
                                <col width='15%'></col>
                                <col width='15%'></col>
                                <tr className={gameBoxStyles.row_header}>
                                    <th>
                                    </th>
                                    <th>
                                    </th>
                                    <th>
                                        Market Line
                                    </th>
                                    <th>
                                        Model Line
                                    </th>
                                    <th>
                                        Win %
                                    </th>
                                    <th>
                                        EV
                                    </th>
                                </tr>
                            </table>
                        </div>
                        <div className={gameBoxStyles.game_table_container}>
                            <table className={gameBoxStyles.game_table}>
                                <col width='13%'></col>
                                <col width='31%'></col>
                                <col width='13%'></col>
                                <col width='13%'></col>
                                <col width='15%'></col>
                                <col width='15%'></col>
                                <tr>
                                    <td>
                                        <div>
                                            <img
                                                className={gameBoxStyles.team_logo}
                                                src={node.away_team_logo_espn}
                                                alt={node.away_team_name}>
                                            </img>
                                        </div>
                                    </td>
                                    <td className={gameBoxStyles.team_name}>
                                        {node.away_team_name}
                                    </td>
                                    <td>
                                        {return_spread(-1 * node.home_line_close)}
                                    </td>
                                    <td style={{borderRight : '1px solid rgba(0, 0, 0, 0.15)'}}>
                                        {return_spread(-1 * node.home_closing_line_rounded_nfelo)}
                                    </td>
                                    <td>
                                        {((1-node.home_probability_nfelo)* 100).toFixed(0) + '%'}
                                    </td>
                                    <td style={set_ev_color(node.away_ev)}>
                                        {(node.away_ev* 100).toFixed(1) + '%'}
                                    </td>
                                </tr>
                                <tr>
                                    <td>
                                        <div>
                                            <img
                                                className={gameBoxStyles.team_logo}
                                                src={node.home_team_logo_espn}
                                                alt={node.home_team_name}>
                                            </img>
                                        </div>
                                    </td>
                                    <td className={gameBoxStyles.team_name}>
                                        {node.home_team_name}
                                    </td>
                                    <td>
                                        {return_spread(node.home_line_close)}
                                    </td>
                                    <td style={{borderRight : '1px solid rgba(0, 0, 0, 0.15)'}}>
                                        {return_spread(node.home_closing_line_rounded_nfelo)}
                                    </td>
                                    <td>
                                        {(node.home_probability_nfelo* 100).toFixed(0) + '%'}
                                    </td>
                                    <td style={set_ev_color(node.home_ev)}>
                                        {(node.home_ev* 100).toFixed(1) + '%'}
                                    </td>
                                </tr>
                            </table>
                        </div>
                    </Link>
                    </div>
                )
            })}
        </div>
    )
}

export default Games